import { useQuery } from '@tanstack/react-query';
import { Field, useField } from 'react-final-form';

import { fetchApps, type TCustomApp } from 'api/apps';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import { withFinalForm } from 'components/shared/FormAdapters/FormDefault/select/baseSelect';
import { Select } from 'components/shared/SelectRB';
import Text from 'components/shared/Typography/Text';

import s from './index.module.css';

const SelectAdapter = withFinalForm<TCustomApp>(Select);

export const CustomAppsBlock = function () {
  const customAppsRes = useQuery({ queryKey: ['mobile-apps'], queryFn: fetchApps });

  const apps = customAppsRes.data ?? [];

  const defaultValue = useField('app').input.value || apps[0];

  return (
    <div className={s.wrapper}>
      <div>
        <Text type="brandon" isStrong weight="500">
          Mobile App Experience
        </Text>
        <Text type="brandon" size="regular" color="gray-600">
          Choose whether to direct travelers to your custom app or the default Travel Portal app.
        </Text>
      </div>

      <Field name="app" defaultValue={defaultValue}>
        {(fieldProps) => (
          <FormGroupAdapter withChildren className={s.selectWrapper} {...fieldProps}>
            <SelectAdapter
              menuPlacement="auto"
              placeholder="Select App"
              isLoading={customAppsRes.isLoading}
              options={apps}
              getOptionLabel={(res) => res.name}
              getOptionValue={(res) => res.id}
              {...fieldProps}
            />
          </FormGroupAdapter>
        )}
      </Field>

      <Text accent color="gray-600" size="regular">
        Want your own branded app?{'\u00A0'}
        <a href="mailto:support@safariportal.app">
          <Text className={s['link-text']}>Contact support</Text>
        </a>
        {'\u00A0'}
        to learn more!
      </Text>
    </div>
  );
};
